// extracted by mini-css-extract-plugin
module.exports = {"staticMapWrapper":"styles_staticMapWrapper__9TAW6","staticMap":"styles_staticMap__3VcsV"};